module.exports = __webpack_public_path__ + "app-static/img/03.31da42fc.png";